import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';
import { hostProblemsDetailFailed, hostProblemsDetailSuccessful } from '../actions';

export default function* hostProblemsDetail(action) {
  try {
    const {
      payload: {
        id,
        created_at_from,
        created_at_to,
        host,
        zbx_address,
      } = {},
    } = action;
    const url = `${BACKEND_URL}/host-problems/${id}/detail`;
    const pool = {
      filter: {
        created_at_from,
        created_at_to,
      },
    };
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      if (data && data.result && data.result.length) {
        data.result = data.result.map(i => ({ ...i, zbx_address, host }));
      }
      yield put(hostProblemsDetailSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(hostProblemsDetailFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(hostProblemsDetailFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
